import { z } from 'zod';

export const batchNewVouchersCreationResultDto = z.object({
  vouchersCreated: z.number(),
});
export type BatchNewVouchersCreationResultDto = z.infer<
  typeof batchNewVouchersCreationResultDto
>;
